import {Steps} from "../constants/constants";

interface Props {
    step: string
}

export const Introduction = (props: Props) => {


    return (
        <div className={'p-repair-form__header'}>

            {props.step !== Steps.CONFIRMED &&
                <>
                    <h1 className="p-repair-form__title">Een reparatieverzoek indienen</h1>

                    <p className="p-repair-form__intro-text">Bij gebreken aan uw woning of onroerend goed kunt u dit via
                        het onderstaande reparatieformulier melden.
                        Door deze zo volledig mogelijk in te vullen kunnen wij uw reparatieverzoek zo snel en volledig
                        mogelijk
                    </p>
                </>
            }

        </div>
    )

}
